// extracted by mini-css-extract-plugin
export default {"header":"collaboration_header__7O1kk"};